import { render, staticRenderFns } from "./TestOrder.vue?vue&type=template&id=216756ec&lang=pug"
import script from "./TestOrder.vue?vue&type=script&lang=js"
export * from "./TestOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports